// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckedStatus_wrapper__jXAOE"};